import React from 'react' 
import { Routes, Route  } from 'react-router-dom'
import Home from './pages/Home.jsx'
import Termsconditions from './pages/Termsconditions.jsx'
import Firstproject from '../src/pages/Pone/Firstproject'
import Fiveproject from '../src/pages/Pone/Fiveproject'
import Fourproject from '../src/pages/Pone/Fourproject' 
import Introduction from '../src/pages/Pone/Introduction' 
import Secondproject from '../src/pages/Pone/Secondproject'
import Thirdproject from '../src/pages/Pone/Thirdproject'
import Finalmodule from '../src/pages/Pone/Finalmodule'
import Designskills from '../src/pages/Ptwo/Designskills'
import Firstdesign from '../src/pages/Ptwo/Firstdesign'
import Secondesign from '../src/pages/Ptwo/Secondesign'
import Thirdesign from '../src/pages/Ptwo/Thirdesign'
import Fourdesign from '../src/pages/Ptwo/Fourdesign'
import Fivedesign from '../src/pages/Ptwo/Fivedesign'
import Dynamicimport from '../src/pages/Pthree/Dynamicimport'
import Performancepatterns from '../src/pages/Pthree/Performancepatterns'
import Staticimport from '../src/pages/Pthree/Staticimport'
import Renderingclient from '../src/pages/Pfour/Renderingclient'
import Renderingintro from '../src/pages/Pfour/Renderingintro'
import Renderingstatic from '../src/pages/Pfour/Renderingstatic'
import Shoppingpage from '../src/pages/Pshop/Shopping.jsx'
import Success from '../src/pages/Pshop/Success.jsx'
import Fail from '../src/pages/Pshop/Fail.jsx'
import Activism from '../src/pages/Pone/Activism.jsx'

const App = () => {
  return (
    <>
         <Routes>
            <Route path='/' element={<Home />} />
            <Route path='/Introduction' element={<Introduction />} />
            <Route path='/ecommerce' element={<Firstproject />} />
            <Route path='/about' element={<Secondproject />} />
            <Route path='/our-team' element={<Thirdproject />} />
            <Route path='/Design' element={<Fourproject />} />
            <Route path='/ux-design' element={<Fiveproject />} />
            <Route path='/performance' element={<Finalmodule />} />
            <Route path='/Design-skills' element={<Designskills />} />
            <Route path='/react-projects' element={<Firstdesign />} />
            <Route path='/react-rendering' element={<Secondesign />} />
            <Route path='/react-components' element={<Thirdesign />} />
            <Route path='/react-states' element={<Fourdesign />} />
            <Route path='/react-events' element={<Fivedesign />} />
            <Route path='/javascript-intro' element={<Dynamicimport />} />
            <Route path='/javascript-arrays' element={<Performancepatterns />} />
            <Route path='/javascript-loops' element={<Staticimport />} />
            <Route path='/javascript-client' element={<Renderingclient />} />
            <Route path='/performance-intro' element={<Renderingintro />} />
            <Route path='/Rendering' element={<Renderingstatic />} />
            <Route path='/Shopping' element={<Shoppingpage />} />
            <Route path='/shopping-success' element={<Success />} />
            <Route path='/shopping-fail' element={<Fail />} />
            <Route path='/activism' element={<Activism />} />
            <Route path='/terms-conditions' element={<Termsconditions />} />
         </Routes>
    </>
  )
}

export default App